// One-slot hand-off for a voice clip recorded OUTSIDE the thread workspace.
//
// The dock mic (TaskEricInput) records on Today, but the voice pipeline —
// transcribe → dispatch → bubbles — lives in ThreadChat and runs there
// unchanged. The recording has to survive a route navigation
// (`/?thread=<id>` remounts Home), so React state can't carry it; this
// module-level slot does. Deliberately NOT a store: one pending clip max,
// consumed exactly once, keyed to the thread it was recorded for so a stale
// clip can never fire into a different conversation the user opens later.
//
// Lifetime: the clip's blob lives in memory only (≤25s audio, ≤2MB — same
// budget as ThreadChat's same-session bubbles). A stash that never gets
// consumed (navigation failed mid-flight) is overwritten by the next record
// or dropped with the page — nothing persists.

import type { StoppedClip } from '@/components/voice/useMediaRecorder'

let pending: { threadId: string; clip: StoppedClip } | null = null

export function stashPendingVoiceClip(threadId: string, clip: StoppedClip): void {
  pending = { threadId, clip }
}

// Returns the clip only for the thread it was stashed for, and clears the
// slot on that read — clear-on-read IS the once-guard (StrictMode's double
// effect run and real remounts both get null on the second read).
export function consumePendingVoiceClip(threadId: string): StoppedClip | null {
  if (!pending || pending.threadId !== threadId) return null
  const { clip } = pending
  pending = null
  return clip
}
